import { render, staticRenderFns } from "./MapPoints.vue?vue&type=template&id=7084a606"
import script from "./MapPoints.vue?vue&type=script&lang=ts"
export * from "./MapPoints.vue?vue&type=script&lang=ts"
import style0 from "./MapPoints.vue?vue&type=style&index=0&id=7084a606&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports